import React, { useState } from "react";
import { Card, Button, Checkbox, Divider, message, Input } from "antd";
import { CheckOutlined, CloseOutlined, CopyOutlined } from "@ant-design/icons";
import { useForm } from "antd/es/form/Form";

const CorporateCard = ({
  clinicDataSetInUpdate,
  setShowMiddleSection,
  setshowAddButton,
}) => {
  const [form] = useForm();
  const [copied, setCopied] = useState(false);
  const [showWidgetLink, setShowWidgetLink] = useState(false);

  const handleCopy = () => {
    const value = clinicDataSetInUpdate?.widget_url;
    if (value) {
      navigator.clipboard.writeText(value);
      setCopied(true);
      message.success("Copied to clipboard!");
      setTimeout(() => setCopied(false), 2000); // revert after 2 seconds
    } else {
      message.warning("No widget URL available to copy");
    }
  };
  return (
    <Card
      style={{
        borderRadius: "10px",
        overflow: "hidden",
        padding: 0,
        backgroundColor: "#f0fafa",
        border: "none",
        width: "950px",
      }}
      bodyStyle={{ padding: 0 }}
    >
      {/* Header */}
      <div
        style={{
          backgroundColor: "#008385",
          color: "#fff",
          textAlign: "center",
          padding: "10px 0",
          fontWeight: "bold",
          fontSize: "16px",
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",
        }}
      >
        {clinicDataSetInUpdate.name}

        {/* ✅ Close Icon */}
        <CloseOutlined
          onClick={() => {
            setShowMiddleSection(false);
            setshowAddButton(true);
          }}
          style={{
            position: "absolute",
            right: 15,
            top: "12%",
            transform: "translateY(-50%)",
            cursor: "pointer",
            fontSize: "16px",
            color: "#fff",
          }}
        />
      </div>

      {/* Body */}
      <div
        style={{
          backgroundColor: "#fff",
          padding: "20px 30px",
          borderBottomLeftRadius: "10px",
          borderBottomRightRadius: "10px",
          textAlign: "center",
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        }}
      >
        {/* Buttons */}
        <div style={{ marginBottom: 10 }}>
          <Button
            type="default"
            onClick={() => {
              if (clinicDataSetInUpdate.page_url) {
                window.open(clinicDataSetInUpdate.page_url, "_blank");
              } else {
                message.warning("No page URL available");
              }
            }}
            style={{
              marginRight: 10,
              backgroundColor: "#f5f5f5",
              borderRadius: "6px",
              border: "1px solid #d9d9d9",
              fontWeight: 500,
            }}
          >
            View page
          </Button>
          <Button
            type="default"
            onClick={() => setShowWidgetLink((prev) => !prev)} // 👈 toggles visibility
            style={{
              backgroundColor: showWidgetLink ? "#0083851a" : "#f5f5f5", // active vs normal
              borderRadius: "6px",
              border: showWidgetLink
                ? "1px solid #008385"
                : "1px solid #d9d9d9",
              fontWeight: 500,
              color: showWidgetLink ? "#008385" : "inherit",
            }}
          >
            {showWidgetLink
              ? "Hide booking widget link"
              : "View booking widget link"}
          </Button>
        </div>

        <Divider style={{ margin: "10px 0" }} />

        {showWidgetLink && (
          <div style={{ justifySelf: "center", width: "34%" }}>
            <Input
              suffix={
                copied ? (
                  <span style={{ color: "green", fontSize: 12 }}>
                    <CheckOutlined /> Copied
                  </span>
                ) : (
                  <CopyOutlined
                    style={{ cursor: "pointer", color: "#1677ff" }}
                    onClick={handleCopy}
                  />
                )
              }
              value={clinicDataSetInUpdate?.widget_url}
              style={{ width: "100%" }}
              placeholder="Booking widget link"
              disabled
            />
          </div>
        )}

        {/* Products Section */}
        <div style={{ textAlign: "left", marginBottom: 20 }}>
          <strong>Products:</strong>
          <div
            
          >
            {clinicDataSetInUpdate.corporate_products?.length > 0 ? (
              clinicDataSetInUpdate?.corporate_products?.map((product) => (
                <Checkbox checked>{product.name}</Checkbox>
              ))
            ) : (
              <div style={{ color: "#999", fontSize: "14px" }}>
                No products added
              </div>
            )}
          </div>
        </div>

        {/* All Fields Section */}
        <div style={{ textAlign: "left", marginBottom: 20 }}>
          <strong>Company Email:</strong>
          <div
            style={{
              marginTop: 8,
              color: clinicDataSetInUpdate?.email ? "#000" : "#999",
            }}
          >
            {clinicDataSetInUpdate?.email || "N/A"}
          </div>
        </div>

        <div style={{ textAlign: "left", marginBottom: 20 }}>
          <strong>Intranet URL:</strong>
          <div
            style={{
              marginTop: 8,
              color: clinicDataSetInUpdate?.intranet_url ? "#000" : "#999",
            }}
          >
            {clinicDataSetInUpdate?.intranet_url || "N/A"}
          </div>
        </div>

        <div style={{ textAlign: "left", marginBottom: 20 }}>
          <strong>Page URL:</strong>
          <div
            style={{
              marginTop: 8,
              color: clinicDataSetInUpdate?.page_url ? "#000" : "#999",
            }}
          >
            {clinicDataSetInUpdate?.page_url || "N/A"}
          </div>
        </div>

        <div style={{ textAlign: "left", marginBottom: 20 }}>
          <strong>Widget URL:</strong>
          <div
            style={{
              marginTop: 8,
              color: clinicDataSetInUpdate?.widget_url ? "#000" : "#999",
            }}
          >
            {clinicDataSetInUpdate?.widget_url || "N/A"}
          </div>
        </div>

        <div style={{ textAlign: "left", marginBottom: 20 }}>
          <strong>Requires Employee Number:</strong>
          <div style={{ marginTop: 8, color: "#000" }}>
            {clinicDataSetInUpdate?.requires_employee_number ? "Yes" : "No"}
          </div>
        </div>

        <div style={{ textAlign: "left", marginBottom: 20 }}>
          <strong>Allow for Admin:</strong>
          <div style={{ marginTop: 8, color: "#000" }}>
            {clinicDataSetInUpdate?.allow_for_admin ? "Yes" : "No"}
          </div>
        </div>

        <div style={{ textAlign: "left", marginBottom: 20 }}>
          <strong>Change Category Label:</strong>
          <div style={{ marginTop: 8, color: "#000" }}>
            {clinicDataSetInUpdate?.change_category_label ? "Yes" : "No"}
          </div>
        </div>

        {clinicDataSetInUpdate?.change_category_label && (
          <div style={{ textAlign: "left", marginBottom: 20 }}>
            <strong>Product Category Label:</strong>
            <div
              style={{
                marginTop: 8,
                color: clinicDataSetInUpdate?.product_category_label ? "#000" : "#999",
              }}
            >
              {clinicDataSetInUpdate?.product_category_label || "N/A"}
            </div>
          </div>
        )}
      </div>
    </Card>
  );
};

export default CorporateCard;
